import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class EquipamentoRdService {

  constructor(
    private http: HttpClient,
    private account: AccountService
  ) { }
  
  urlBase = `${SCAMP_API.accountApiV1}/rd-equipamentos`;


  add(data: any) {
    return this.http.post(`${SCAMP_API.accountApiV1}/rd-equipamentos`, data,
      { headers: this.account.composeHeaders() });
  }

  /* addPromise(data: any) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    //myHeaders.append("header", this.account.getHearderAuthorization())


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      };

     return  fetch("https://localhost:5001/v1/rd-equipamentos", requestOptions);

  } */

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/rd-equipamentos/${id}`,
      { headers: this.account.composeHeaders() });
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rd-equipamentos`,
      { headers: this.account.composeHeaders() });
  }

  getAllWithDet(rdId: number): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rd-equipamentos/with-det/${rdId}`,
      { headers: this.account.composeHeaders() });
  }

  getAllWithDetPromise(rdId: number): Promise<Response> {

    const url = `${this.urlBase}/with-det/${rdId}`;
    
    return fetch(url, {
      method: 'GET', 
      headers: this.account.getHearderAuthorization()
    })
  }


  deleteById(id: number) {
    return this.http.delete(`${SCAMP_API.accountApiV1}/rd-equipamentos/${id}`,
      { headers: this.account.composeHeaders() });
  }


  isUniqueNome(nome: string, id: number): Observable<boolean> {
    return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/rd-equipamentos/is-unique`, { nome, id },
      { headers: this.account.composeHeaders() });
  }
}

